import { useOutletContext } from "react-router";

import { ExistingDestination } from "@prequel/react";

import TestDestinationConnection from "../TestDestinationConnection";

type DestinationConnectionDetailsProps = {
  destination: ExistingDestination;
};

const DestinationConnectionDetails = () => {
  const { destination } = useOutletContext<DestinationConnectionDetailsProps>();
  return <TestDestinationConnection key={destination.id} existingDestination={destination} />;
};

export default DestinationConnectionDetails;
